// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"5f3d76c1","93":"62c03675","455":"a6687822","799":"1cd4d4e5","941":"3b525a17"}[chunkId] + ".chunk.css";
};